import { ReactNode } from 'react'

import { cn } from '@/app/utils'

export type PermissionsBlockRow = {
  id: string
  premise: string
  permissions: string
}

export type PermissionsBlockProject = {
  id: string
  name: string
  rows: PermissionsBlockRow[]
}

type Props = {
  projects: PermissionsBlockProject[]
  headerDate?: ReactNode
  className?: string
}

export const PermissionsBlock = ({
  projects,
  headerDate,
  className
}: Props) => (
  <div
    className={cn(
      'mb-20 flex flex-col gap-20 rounded-12 bg-white p-16 sm:mb-16 sm:gap-16 sm:p-12 xxs:mb-12',
      className
    )}
  >
    <div className="flex items-center justify-between">
      <h4 className="font-bold text-24 sm:text-18">Доступы</h4>
      {headerDate}
    </div>
    {projects.map(({ id: projectId, name: projectName, rows }) => (
      <div key={projectId} className="flex flex-col gap-12">
        <h5 className="font-semibold text-20 sm:text-16">{projectName}</h5>
        <ul className="flex flex-col gap-12">
          {rows.map(({ id: rowId, premise, permissions }) => (
            <li
              key={rowId}
              className="grid grid-cols-2 gap-12 border-b border-grey-20 pb-12 text-grey-80 text-16 last:border-none sm:text-14"
            >
              <div className="break-words">{premise}</div>
              <div className="break-words">{permissions}</div>
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
)
